export default "__VITE_ASSET__BFW7BFAw__"